import StylesParams from '../FileShareOoi/stylesParams';

export default StylesParams;
